module.exports = __webpack_public_path__ + "media/images/redesign-images/get-inspired/gi-design-3-d5bdc3ebbd78dab348519380748d91dd.jpg";